// Tipo da carteira pelas colunas da tbCarteira, nunca pelo nome ("Processos", "Cobrança Juridica"...):
// cbCobranca = carteira de cobrança (a de processos não é); isJuridico (cbIsJuridico) = carteira jurídica.
// As listas /carteira/list-all, /carteira/usuario-contexto e /carteira/destinos-migracao já trazem os dois campos.

/** Carteira de cobrança (fichas e contratos): todas menos a de processos. */
export const ehCarteiraDeCobranca = (carteira) => Boolean(carteira) && (carteira.cbCobranca === true || carteira.cbCobranca === 1);

/** Carteira jurídica (cadastro da carteira). */
export const ehCarteiraJuridica = (carteira) => Boolean(carteira) && (carteira.isJuridico === true || carteira.isJuridico === 1);
